module.exports = __webpack_public_path__ + "img/PW.49233bc2.png";